export class LivePreviewError extends Error {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : 'Live preview is inactive. Could not retrieve the live preview token');
        this.name = 'LivePreviewError';
    }
}
//# sourceMappingURL=LivePreviewError.js.map